const quickbuyHtmlCache = new Map();

class MCBQuickBuyButton extends HTMLElement {
  constructor() {
    super();
    this.viewVariantsButton = this.querySelector('[data-open-variant-selector]');
    this.productHandle = this.dataset.productHandle;
    this.isLoading = false;
    this.variantSelector = null;

    this.setupEventListeners();

    document.addEventListener('on:cart:add', () => {
      if (this.variantSelector) {
        this.hideVariantSelector();
      }
    });
  }

  setupEventListeners() {
    if (!this.viewVariantsButton || !this.productHandle) return;
    this.viewVariantsButton.addEventListener('click', () => {
      if (this.isLoading) return;
      this.toggleVariantSelector();
    });
  }

  toggleVariantSelector() {
    if (this.variantSelector) {
      this.hideVariantSelector();
      return;
    }
    this.showVariantSelector();
  }

  async fetchVariantSelectorHtml() {
    if (quickbuyHtmlCache.has(this.productHandle)) {
      return quickbuyHtmlCache.get(this.productHandle);
    }
    const url = `/products/${encodeURIComponent(this.productHandle)}?view=quickbuy`;
    const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) {
      throw new Error(`Quickbuy fetch failed: ${response.status}`);
    }
    const html = await response.text();
    quickbuyHtmlCache.set(this.productHandle, html);
    return html;
  }

  async showVariantSelector() {
    this.isLoading = true;
    this.classList.add('is-loading');

    try {
      const html = await this.fetchVariantSelectorHtml();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const wrapper = doc.querySelector('.variant-selector-wrapper');

      if (!wrapper) {
        throw new Error('Quickbuy variant selector wrapper not found in response');
      }

      this.appendChild(wrapper);
      this.variantSelector = this.querySelector('.variant-selector-wrapper');

      const closeButton = this.querySelector('.variant-selector-close');
      const variantSelect = this.querySelector('.variant-selector');
      const addToCartButton = this.querySelector('.add-to-cart-button');

      this.boundVariantChangeHandler = (event) => this.handleVariantChange(event, addToCartButton);
      this.boundHideVariantSelector = () => this.hideVariantSelector();

      if (variantSelect) variantSelect.addEventListener('change', this.boundVariantChangeHandler);
      if (closeButton) closeButton.addEventListener('click', this.boundHideVariantSelector);
    } catch (err) {
      console.error('MCBQuickBuyButton: failed to load variant selector', err);
    } finally {
      this.isLoading = false;
      this.classList.remove('is-loading');
    }
  }

  handleVariantChange(event, addToCartButton) {
    const selectedValue = event.target.value;
    const isValidVariant = selectedValue !== '0';

    addToCartButton.disabled = !isValidVariant;

    this.querySelector('.js-product').dispatchEvent(new CustomEvent('on:variant:change', {
      bubbles: true,
      detail: {
        variant: { id: selectedValue },
      }
    }));
  }

  hideVariantSelector() {
    if (this.variantSelector) {
      const variantSelect = this.querySelector('.variant-selector');
      const closeButton = this.querySelector('.variant-selector-close');

      if (variantSelect) variantSelect.removeEventListener('change', this.boundVariantChangeHandler);
      if (closeButton) closeButton.removeEventListener('click', this.boundHideVariantSelector);

      this.variantSelector.remove();
      this.variantSelector = null;
      this.boundVariantChangeHandler = null;
      this.boundHideVariantSelector = null;
    }
  }
}

customElements.define('mcb-quickbuy-button', MCBQuickBuyButton);
